
<template>
  <v-btn @click="openExternalAccount()">
    <v-icon :color="getSocialiteColor(externalAccount.driver)" left>{{getSocialiteIcon(externalAccount.driver)}}</v-icon>{{externalAccount.nickname}}<v-icon right small>mdi-open-in-new</v-icon>
  </v-btn>
</template>

<script>
import socialiteMixin from "@/mixins/socialiteMixin"

export default {
  name: "SocialiteOpenButton",
  mixins: [socialiteMixin],
  props: {
    externalAccount: {
      type: Object,
      required: true
    }
  },
  methods: {
    openExternalAccount() {
      this.$common.openExternalLink(this.externalAccount.url)
    },
  }
};
</script>